import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import './RegisterBet.scss';

function RegisterBet() {
  const location  = useLocation();
  const { t } = useTranslation();

  return (
    <div className="register-bet">
      <div className="register-bet__title">
        { t('betslip.bookingCode') }
      </div>
      <div className="register-bet__id">
        { location.hash.split('=')[1] }
      </div>
    </div>
  );
}

export default RegisterBet;
